import * as React from "react";

export const OuterShade = ({rect, outSize, style}) => (
    <svg {...{
        className: "outer-shade",
        viewBox: toViewBox({x:0,y:0,...outSize}),
        style,
    }}>
        <path {...{
            d: (() => {
                const r = rect;
                return [
                    "M 0,0",
                    `l ${outSize.width},0`,
                    `l 0,${outSize.height}`,
                    `l ${-outSize.width},0`,
                    `l 0,${-outSize.height}`,

                    `M ${r.x},${r.y}`,
                    `l ${r.width},0`,
                    `l 0,${r.height}`,
                    `l ${-r.width},0`,
                    `l 0,${-r.height}`,
                    "Z"

                ].join(" ");
            })(),
            fill: "rgba(0,0,0,.3)",
            fillRule: "evenodd",
        }}/>
    </svg>
);

const toViewBox = (r) => [r.x, r.y, r.width, r.height].join(" ");
